module.exports = __webpack_public_path__ + "static/media/8.35ff1f0a.svg";